import { User, Serializable } from '@tokeet/tv3-platform'

export class LoginResponse extends Serializable<LoginResponse> {
  token: string
  user: User
  mfa_bypass?: string

  static deserialize(data: object): LoginResponse {
    const loginResponse = new LoginResponse()

    loginResponse.token = data['token']
    loginResponse.user = User.deserialize(data)
    loginResponse.mfa_bypass = data['mfa_bypass']

    return loginResponse
  }
}
